import { DatesTimesService } from './../../../utils/dates-times/dates-times.service';
import { IBulkResponse } from './../../../interfaces/pages/bulk/bulk.interface';
import { IStructFireBase } from "./../../../interfaces/shared/struct-firebase.interface";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalSize } from "@signal/component-library/efx-modal";
import { FieldFormHelperService } from "src/app/helpers/field-form-helper.service";

@Component({
    selector: "app-modal-eliminacion-masiva",
    templateUrl: "./modal-eliminacion-masiva.component.html",
    styleUrls: ["./modal-eliminacion-masiva.component.scss"],
    standalone: false
})
export class ModalEliminacionMasivaComponent implements OnInit {
  @Input() inShowModal: boolean;
  @Input() dataSeleccionados: any[];
  @Input() set inStructSubDomain(inStruct: IStructFireBase[]) {
    this.structSubDomain = inStruct.filter(
      (field) => field.visible && field.editable
    );
  }

  @Output() onGuardar: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  form: FormGroup;
  modalSize = ModalSize;

  structSubDomain: any[] = [];
  comprobanteBulk: IBulkResponse;
  showsucces: boolean = false;

  get arrayUpdatesControl(): FormArray {
    return this.form?.get("camposUpdate") as FormArray;
  }

  get disableSave(): boolean {
    return (
      !this.arrayUpdatesControl?.value[0]?.fieldToChange ||
      !this.arrayUpdatesControl?.value[0]?.newValue
    );
  }

  constructor(
    private fb: FormBuilder,
    private datesTimesService: DatesTimesService,
    private fieldHelper: FieldFormHelperService
  ) {
    this.generaFormulario();
    this.agregarUpdatesVacio();
  }

  getStructSelect(name: string): IStructFireBase {
    return this.structSubDomain?.find(struct => struct.name === name);
  }

  generaFormulario() {
    this.form = this.fb.group({
      camposUpdate: this.fb.array([]),
      comentarioAudit: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.showsucces = false;
  }

    onSubmit() {
    const fieldsToUpdate = this.arrayUpdatesControl.value;
    const comentarioAudit = this.form.get('comentarioAudit')?.value || '';

    const enrichedFields: any[] = [];

    fieldsToUpdate.forEach((criterio: any) => {
      const struct = this.structSubDomain.find(s => s.name === criterio.fieldToChange);
      if (struct) {
        // Formatear fecha según patrón del campo
        criterio.newValue = this.fieldHelper.formatDateByPattern(criterio.newValue, struct.pattern);

        // Resolver el texto del campo asociado (associateField) si es un select
        const associateText = this.fieldHelper.resolveAssociateText(struct, criterio.newValue);
        enrichedFields.push(criterio);
        if (associateText !== null && struct.associateField) {
          enrichedFields.push({ fieldToChange: struct.associateField, newValue: associateText });
        }
      } else {
        enrichedFields.push(criterio);
      }
    });

    this.onGuardar.emit({ fieldsToUpdate: enrichedFields, comentarioAudit });
    this.closetModal();
  }

  closetModal() {
    this.arrayUpdatesControl.clear();
    this.agregarUpdatesVacio();
    this.form.get('comentarioAudit')?.setValue('');
    this.onCloseModal.emit();
  }

  agregarUpdatesVacio(): void {
    const group = this.fb.group({
      fieldToChange: new FormControl("", [Validators.required]),
      newValue: new FormControl("", [Validators.required]),
    });

    // Cuando cambia el campo seleccionado, actualizar los validadores de newValue según el struct
    group.get('fieldToChange')?.valueChanges.subscribe((fieldName: string | null) => {
      const struct = this.structSubDomain.find(s => s.name === fieldName);
      const newValueControl = group.get('newValue');
      if (newValueControl) {
        const structValidators = struct ? this.fieldHelper.buildValidatorsFromStruct(struct) : [];
        newValueControl.setValidators([Validators.required, ...structValidators]);
        newValueControl.setValue('');
        newValueControl.updateValueAndValidity();
      }
    });

    this.arrayUpdatesControl.push(group);
  }

  eliminarUpdate(index: number) {
    this.arrayUpdatesControl.removeAt(index);
  }

}
